import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateUserDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_USER = "UPDATE_USER";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const updateUser = async (data: UpdateUserDto): Promise<void> => {
  const response = await usersApi.usersControllerUpdateUser(data);

  return response.data;
};

export const useUpdateUser = (
  user: UserProfileDto | null,
): {
  updateUser: (data: UpdateUserDto) => void;
  updateUserAsync: (data: UpdateUserDto) => Promise<void>;
  updateUserEnabled: boolean;
  updateUserError: Error | null;
  isSuccessUpdateUser: boolean;
  isPendingUpdateUser: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_UPDATE_USER],
    mutationFn: enabled ? updateUser : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_USERS] });
    },
  });

  return {
    updateUser: mutate,
    updateUserAsync: mutateAsync,
    updateUserEnabled: enabled,
    updateUserError: error,
    isSuccessUpdateUser: isSuccess,
    isPendingUpdateUser: isPending,
  };
};
